import React from 'react';

// The initial push notification context
const pushContext = React.createContext({});

export default pushContext;
